import styled from "styled-components";
import Grid from "@material-ui/core/Grid";

// components
import SectionContainer from "core/SectionContainer";
import Heading from "core/Heading";
import { MaterialUIGridContainer } from "core/MaterialUI";

// styles
import breakpoints from "core/breakpoints";
import colors from "core/colors";
import {
    BorderBottomLinkStylesDefault,
    BorderBottomLinkStylesHover
} from "core/Typography";
import Avatar from "core/Avatar";
import { easingSeconds } from "core/animation";

//helpers
import { convertPxToRem } from "frontend/components/helpers";

// constants
const MATERIAL_NEGATIVE_MARGIN = 16;
const MIN_HEIGHT_TOTAL_PX = 661;
const MIN_HEIGHT_TOTAL_REM =
    (MIN_HEIGHT_TOTAL_PX + MATERIAL_NEGATIVE_MARGIN) / 16;
const TOP_BOTTOM_PADDING_REM = 36 / 16; // 36px to REM
const GRID_CONTAINER_MIN_HEIGHT_REM =
    MIN_HEIGHT_TOTAL_REM - TOP_BOTTOM_PADDING_REM * 2; // calculates total of 661px -> REM height for the black area

// container
export const ImageDetailHeroSectionContainer = styled(SectionContainer)`
    > section {
        /* mobile-only styles: */
        padding: 0;

        /* tablet-only styles: */
        @media (min-width: ${breakpoints.tablet
                .rem}) and (max-width: ${breakpoints.beforeDesktop.rem}) {
            padding: ${TOP_BOTTOM_PADDING_REM}rem 1.25rem; /* 36px 20px */
        }

        /* desktop-only styles: */
        @media (min-width: ${breakpoints.desktop.rem}) {
            padding: ${TOP_BOTTOM_PADDING_REM}rem 1.5rem; /* 36px 24px */
        }
    }
`;

export const ImageDetailGridContainer = styled(MaterialUIGridContainer)`
    // tablet + desktop styles:
    @media (min-width: ${breakpoints.tablet.rem}) {
        min-height: ${GRID_CONTAINER_MIN_HEIGHT_REM}rem;
    }
`;

/********************
 *
 * left column styles:
 *
 ********************/
export const LeftColGridItem = styled(Grid)`
    text-align: center; // justify center is not working with image
`;

/********************
 *
 * right column styles:
 *
 ********************/
export const RightColGridItem = styled(Grid)`
    /* Mobile-only style: */
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        padding: ${TOP_BOTTOM_PADDING_REM}rem 0.9375rem; /* 36px 15px*/
    }
`;

export const RightColumnInnerContainer = styled.div`
    margin: 0 auto;
    max-width: 28.125rem;

    @media (min-width: ${breakpoints.tablet.rem}) {
        max-width: 21.875rem;
    }
`;

// for CreatorInfo:
export const TitleBlockContainer = styled.div`
    margin-bottom: 1.5rem; /* 24px */
`;

export const ImageTitle = styled.h1`
    font-size: 1.375rem; /* 22px */
    line-height: 1.249375;
    margin-bottom: 1rem; /* 16px */
    color: ${colors.primary.diamond};
`;

export const CreatorName = styled(Heading)``;

export const CreatorAvatar = styled(Avatar)`
    /* Custom breakpoint for this view */
    @media (min-width: 60rem) and (max-width: ${breakpoints.beforeDesktop
            .rem}) {
        height: 2.188rem; /* 35px */
        width: 2.188rem; /* 35px */
    }
`;

export const AvatarLink = styled.a`
    ${CreatorAvatar} {
        opacity: 1;
        transition: all ${easingSeconds};
    }

    &:hover {
        ${CreatorAvatar} {
            opacity: 0.6;
        }
    }
`;

export const NameLink = styled.a`
    ${BorderBottomLinkStylesDefault}
    border-color: transparent;
    color: ${colors.primary.diamond};
    padding-bottom: 0;

    &:hover {
        ${BorderBottomLinkStylesHover}
        border-color: ${colors.accent.darkMode.suenosBuenos};
        color: ${colors.accent.darkMode.suenosBuenos};
    }
`;

export const CreatorContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: center;

    ${AvatarLink} {
        margin-right: 1rem; /* 16px*/
    }
`;

export const CreatorCountry = styled.div`
    margin-left: ${convertPxToRem({ px: 10.5 })};
`;
